export default __webpack_public_path__ + "static/media/welcome.b4d6a6d9.png";